import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { StateType } from 'types';
import { selectIsLoading, selectPartnerDetails, selectPartnerMembers } from 'redux/selectors/partners';
import { getPartnerById, getPartnerTeamMembers } from 'redux/actions/partners';
import { selectPartnerId, selectUserType } from 'redux/selectors/auth';

const mapStateToProps = (state: StateType) => ({
  details: selectPartnerDetails(state),
  isLoading: selectIsLoading(state),
  members: selectPartnerMembers(state),
  userType: selectUserType(state),
  userPartnerId: selectPartnerId(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getPartnerById,
    getPartnerTeamMembers,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
